/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conn_ConnectedInputs */

const cs_ebr_conn_connected = /** @type {(inputs: Ebr_Conn_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojeno`)
};

const en_ebr_conn_connected = /** @type {(inputs: Ebr_Conn_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Ebr_Conn_ConnectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_connected = /** @type {((inputs?: Ebr_Conn_ConnectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_ConnectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_connected(inputs)
	return cs_ebr_conn_connected(inputs)
});